import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";

export const addUpdateVendor = async (payload) => {
  try {
    return await postRequest(urls.ADD_UPDATE_VENDOR, payload);
  } catch (err) {
    return err?.response;
  }
};
